module.exports = __webpack_public_path__ + "img/ST.b435df97.svg";